/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
// import { RouteComponentProps } from 'react-router-dom'
import styled from 'styled-components'
import { PlusOutlined } from '@ant-design/icons'
import { Col, Row, Space } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { ListReq, DeleteReq } from 'Store/categories/types'
import { selectActionEvent, selectList, selectListEvent, selectListFilter } from 'Store/categories/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { categoriesListAPI, deleteCategoriesAPI } from 'Store/categories/api'
import { PrimaryButton } from 'Components/button'
import HomePageLayout from 'Pages/Layout/PageLayout'
import Detail from './detail'
import { ConfirmDailog, EventModal, LoadingView } from 'Components/modal'
import { clearEventAction, filterAction } from 'Store/categories/actions'
import CategoryCollapse from './CategoryCollapse'
import Category from 'Components/form/Category'

type Props = {} & ReduxProps

const Manufactuer: React.FunctionComponent<Props> = props => {
  const { currentUser, listEvent, dataList, event, listFilter } = props
  const dispatch = useDispatch()
  const [drawer, setDrawer] = useState(false)
  const [selectedID, setSelectedID] = useState(0)
  const [pageMode, setPageMode] = useState('create' as 'create' | 'edit' | 'deleted')
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)

  const [filter, setFilter] = useState({
    keyword: '',
    categories: [] as number[],
  })

  const onGetDataList = (): void => {
    const req: ListReq = {
      keyword: filter.keyword,
      merchant_id: currentUser?.activeMerchant?.id || 0,
      include_child: true,
    }
    dispatch(categoriesListAPI(req, currentUser.accessToken))
  }

  const onDeleteUom = (id: number): void => {
    const req: DeleteReq = {
      id,
    }
    dispatch(deleteCategoriesAPI(req, currentUser.accessToken))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetDataList()
    }
  }, [])

  const onFilter = (key: string, val: any) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const onOpenDrawer = () => {
    setDrawer(true)
  }

  const onCloseDrawer = () => {
    setDrawer(false)
  }

  const onClickDelete = (id: number) => {
    setPageMode('deleted')
    setSelectedID(id)
    onOpenConfirmDelete()
  }

  const onConfirmDelete = () => {
    onDeleteUom(selectedID)
    onCloseConfirmDelete()
  }

  const onOpenConfirmDelete = () => {
    setConfirmDeleteDialog(true)
  }

  const onCloseConfirmDelete = () => {
    setConfirmDeleteDialog(false)
  }

  const onClickCreate = () => {
    setPageMode('create')
    setSelectedID(0)
    onOpenDrawer()
  }

  const onClickEdit = (id: number) => {
    setPageMode('edit')
    setSelectedID(id)
    onOpenDrawer()
  }

  const onSuccess = () => {
    onCloseDrawer()
    onGetDataList()
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onDeleteSuccess = (): void => {
    clearEvent()
    onGetDataList()
  }

  const onClickSearch = () => {
    dispatch(filterAction({ filterValue: filter.categories || [] }))
  }

  const DetailDrawer = (
    <Detail
      mode={pageMode}
      id={selectedID}
      visible={drawer}
      onCloseDrawer={onCloseDrawer}
      onSuccess={onSuccess}
    />
  )

  const ConfirmDeleteModal = (
    <ConfirmDailog
      isShow={confirmDeleteDialog}
      handleOk={onConfirmDelete}
      handleCancel={onCloseConfirmDelete}
    />
  )

  const LoadingModal = (
    <EventModal
      event={[event]}
      enable={pageMode === 'deleted'}
      successCalback={onDeleteSuccess}
      errorCalback={clearEvent}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="space-between" align="bottom">
        <MyCol xs={24} md={12}>
          <Space size="middle" align="end">
            <SearchArea>
              <Category
                placeholder="ค้นหาชื่อหมวดหมู่สินค้า"
                data={filter.categories}
                categories={dataList.data}
                handleChange={(val: []) => onFilter('categories', val)}
              />
            </SearchArea>
            <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
          </Space>
        </MyCol>
        <MyCol>
          <Space size="middle">
            <PrimaryButton text="หมวดหมู่สินค้า" icon={<PlusOutlined />} onClick={onClickCreate} />
          </Space>
        </MyCol>
      </Row>
    </FilterWrapper>
  )

  return (
    <>
      <HomePageLayout
        selected="categories"
        title="หมวดหมู่สินค้า"
        label="รายการหวดหมู่ของผลิตภัณฑ์ สินค้า ที่ร้านเราจัดจำหน่าย"
      >
        {FilterContent}
        <ContentWrapper>
          <CategoryCollapse data={listFilter} onClickDelete={onClickDelete} onClickEdit={onClickEdit} />
        </ContentWrapper>
        {DetailDrawer}
        {ConfirmDeleteModal}
        {LoadingModal}
        <LoadingView isShow={listEvent.IsLoading} />
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    dataList: selectList(state),
    listEvent: selectListEvent(state),
    event: selectActionEvent(state),
    listFilter: selectListFilter(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const MyCol = styled(Col)`
  margin-top: 10px;
`

const SearchArea = styled.div`
  //width: 300px;
`

const ContentWrapper = styled.div`
  margin-top: 20px;
`

export default connect(mapStateToProps)(Manufactuer)
